import React, {useState} from 'react';
import * as R from 'ramda';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {useTranslation} from 'react-i18next';
import Icon from '@/views/shared/Icon';
import styles from '@/b2b/index.module.css';
import {isMobile} from 'react-device-detect';

const Pop = ({provider, icon}) => {
  const [modal, setModal] = useState(false);
  const [content, setContent] = useState(provider);
  const {t: tr} = useTranslation();

  const handleClick = () => {
    setModal(!modal);
    if (!modal) {
      setContent(provider);
    }
  };

  const Content = content.component;
  const props = R.dissoc('component')(content);

  return (
    <>
      <Button className='btn btn-sm' onClick={handleClick}>
        <span>
          {' '}
          <Icon icon={icon} />{' '}
        </span>
      </Button>
      <Modal
        isOpen={modal}
        modalClassName={isMobile ? styles.modal_overlay_container : ''}
        className={isMobile ? styles.modal_desktop_width : styles.modal}
        scrollable='true'
        centered
      >
        <Content {...props} setContent={setContent} handleClick={handleClick} />
        <ModalFooter>
          <Button className={styles.modal_close} onClick={handleClick}>
            {' '}
            {tr('close')}{' '}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

const PopError = ({error}) => {
  const {t: tr} = useTranslation();
  const [modal, setModal] = useState(false);

  const handleClick = () => {
    setModal(!modal);
  };
  const closeBtn = (
    <span
      role='button'
      tabIndex={0}
      className={styles.modal_close}
      onClick={handleClick}
      onKeyDown={handleClick}
    >
      &times;
    </span>
  );

  return (
    <>
      <ModalHeader
        toggle={handleClick}
        close={closeBtn}
        className={styles.modal_header}
      >
        {tr('pop_error')}
      </ModalHeader>
      <ModalBody>{error}</ModalBody>
    </>
  );
};

export default Pop;
export {PopError};
